import { render } from "./FullDayView.vue?vue&type=template&id=58623637"
import script from "./FullDayView.vue?vue&type=script&lang=js"
export * from "./FullDayView.vue?vue&type=script&lang=js"

import "./FullDayView.vue?vue&type=style&index=0&id=58623637&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__